






































import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import Combobox from '../../core/components/Combobox.vue';
import FarmingDetail from '../components/FarmingDetail.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import PageTitle from '../../core/components/PageTitle.vue';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { paramsOptions } from '../../core/models';
import { getParameterFromUrl } from '../../core/utils/';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { InsuranceServices } from '../api/InsuranceServices';
import loading from 'vue-loading-overlay'

@Component({
    components: {
        loading,
        Summary,
        Combobox,
        Button,
        Input,
        FarmingDetail,
        PageTitle
    }
})
export default class InsuranceHarvestManagementDetail extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper
) {
    farmingId: null | string = '';
    itemsInsuranceFarmings:Array<object> = [];
    allCropTypeOptions:Array<object> = [];
    ranchStates:Array<object> = [];
    optionsInsuranceCompany:Array<object> = [];
    showFarmingDetail: boolean = false;
    companyFarmingPatchData: object = {};
    createFarming: boolean = false;
    patchFarmingTitle: string = 'Detalle de Zafra';
    pageTitle: string = 'Crear Zafra de Empresa';
    editingFarming: boolean = false;
    detailCalled: boolean = false;

    addFarmingNameToModalTitle(farmingName: string){
        this.pageTitle = this.patchFarmingTitle;
        this.pageTitle += ' <span class='+"subtitle-1"+'> ' + farmingName + '</span>'
    }

    @Watch('allCropTypeOptions')
    observableCropTypes(options) {
        if(options && options.length > 0){
            this.setFarmingId();
        }
    }

    @Watch('$_getInsuranceProperties', { immediate: true, deep: true })
    observableProperties() {
        this.assignPropertiesData();
    }

    updateCreateFarming(value: boolean){
        this.createFarming = value;
    }

    mounted() {
        this.$nextTick(() => {
            
        });
    }

    visibilityFarmingPage(value){
        this.showFarmingDetail = value;
    }

    setFarmingId(){
      this.farmingId = getParameterFromUrl(paramsOptions.farming_id);
      if(this.farmingId == null){
        this.updateCreateFarming(true);
        this.visibilityFarmingPage(true);
      }else{
         
         this.getDetailCompanyFarming(this.farmingId);
      }
    }

    setInsuranceCompanies() {
        let insuranceCompanies = this.$_getInsuranceProperties['insurance_companies'];
        this.optionsInsuranceCompany = insuranceCompanies;
    }

    assignPropertiesData() {
            this.visibilityFarmingPage(false);
            this.allCropTypeOptions = this.$_getInsuranceProperties['harvest_type'];
            this.ranchStates = this.$_getInsuranceProperties['ranch_states'];
            let insuranceFarmings =
                this.$_getInsuranceProperties['insurance_farmings'] !== undefined
                    ? this.$_getInsuranceProperties['insurance_farmings']
                    : [];
            this.itemsInsuranceFarmings = insuranceFarmings;
            this.setInsuranceCompanies();
    }

    getDetailCompanyFarming(farmingId) {
        let self = this;
        if(!this.detailCalled){
            InsuranceServices.getFarmingDetail(farmingId)
                .then(res => {
                    self.editingFarming = true;
                    self.$set(res, 'farming_id', farmingId);
                    self.companyFarmingPatchData = res;
                    self.addFarmingNameToModalTitle(res['name'])
                    self.detailCalled = true;
                })
                .catch(error => {
                    this.$_catchLoadingDialog({
                        response: error.response.data || {},
                        alternative_msg: 'Error al obtener detalle de zafra',
                    });
                    
            }).finally(() => {
                self.visibilityFarmingPage(true);
            })
        }
    }

    backToFarmingList() {
        this.$router.push(NAME_ROUTES.INSURANCE_FARMING_MANAGEMENT.path);
    }
}
